import React from 'react'
import { Form, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FormGroupProps } from '../types/view_product';

const FormGroup = ({controlId, tValue, value, placeholder, onChange, readOnly}: FormGroupProps) => {
  const { t } = useTranslation();
  return (
    <div>
         <Form.Group as={Col} controlId={controlId}>
                                <Form.Label>{t(tValue)}</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={value}
                                  placeholder={placeholder}
                                  onChange={onChange}
                                  readOnly={readOnly}
                                />
         </Form.Group>
    </div>
  )
}

export default FormGroup